import { render } from "./Splash.vue?vue&type=template&id=6e0553da&scoped=true"
import script from "./Splash.vue?vue&type=script&lang=js"
export * from "./Splash.vue?vue&type=script&lang=js"

import "./Splash.vue?vue&type=style&index=0&id=6e0553da&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6e0553da"

export default script